import MainContainer from '@/views/containers/MainContainer/MainContainer.vue';
import { RouteRecordRaw } from 'vue-router';

const APP_TITLE = 'Home+Project';

const PlantsHub = () =>
  import(
    /* webpackChunkName: "page-plants-hub" */ '@/views/pages/PlantsHub/PlantsHub.vue'
  );
const PlantsListPage = () =>
  import(
    /* webpackChunkName: "page-plants-list" */ '@/views/pages/PlantsHub/PlantsList/PlantsList.vue'
  );
const PlantDetailHub = () =>
  import(
    /* webpackChunkName: "page-plant-detail" */ '@/views/pages/PlantDetail/PlantDetail.vue'
  );
const PlantDashboardPage = () =>
  import(
    /* webpackChunkName: "page-plant-dashboard" */ '@/views/pages/PlantDetail/PlantDashboard/PlantDashboard.vue'
  );
const PlantDevicesPage = () =>
  import(
    /* webpackChunkName: "page-plant-devices" */ '@/views/pages/PlantDetail/PlantDevices/PlantDevices.vue'
  );
const PlantSettingsPage = () =>
  import(
    /* webpackChunkName: "page-plant-c300eos-settings" */ '@/views/pages/PlantDetail/PlantC300EOSSettings/PlantC300EOSSettings.vue'
  );
const PlantRoomPage = () =>
  import(
    /* webpackChunkName: "page-plant-room" */ '@/views/pages/PlantDetail/PlantRoom/PlantRoom.vue'
  );
const AutomationWizardPage = () =>
  import(
    /* webpackChunkName: "page-assign-room-object" */ '@/views/pages/PlantDetail/PlantRoom/AutomationWizard/AutomationWizard.vue'
  );
const ThermoWizardPage = () =>
  import(
    /* webpackChunkName: "page-assign-thermo-room-object" */ '@/views/pages/PlantDetail/PlantRoom/ThermoWizard/ThermoWizard.vue'
  );
const LoggedOutPage = () =>
  import(
    /* webpackChunkName: "page-logged-out" */ '@/views/pages/LoggedOut/LoggedOut.vue'
  );
const UserNotAllowedPage = () =>
  import(
    /* webpackChunkName: "page-user-not-allowed" */ '@/views/pages/UserNotAllowed/UserNotAllowed.vue'
  );
const CommandsGroupsPage = () =>
  import(
    /* webpackChunkName: "page-commands-groups" */ '@/views/pages/PlantDetail/CommandsGroups/CommandsGroups.vue'
  );
const CommandWizard = () =>
  import(
    /* webpackChunkName: "page-wizard-command" */ '@/views/pages/PlantDetail/CommandsGroups/CommandWizard/CommandWizard.vue'
  );
const PlantScenesPage = () =>
  import(
    /* webpackChunkName: "page-plant-scenes" */ '@/views/pages/PlantDetail/PlantScenes/PlantScenes.vue'
  );
const SceneWizard = () =>
  import(
    /* webpackChunkName: "page-wizard-scene" */ '@/views/pages/PlantDetail/PlantScenes/SceneWizard/SceneWizard.vue'
  );
const PlantAlarmSystem = () =>
  import(
    /* webpackChunkName: "page-plant-alarmsystem" */ '@/views/pages/PlantDetail/PlantAlarmSystem/PlantAlarmSystem.vue'
  );
const EntrancePlantDetailHub = () =>
  import(
    /* webpackChunkName: "page-entranceplant-detail" */ '@/views/pages/EntrancePlantDetail/EntrancePlantDetail.vue'
  );
const EntrancePlantDashboardPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-dashboard" */ '@/views/pages/EntrancePlantDetail/EntrancePlantDashboard/EntrancePlantDashboard.vue'
  );
const EntrancePlantGatePage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-gate" */ '@/views/pages/EntrancePlantDetail/EntrancePlantGate/EntrancePlantGate.vue'
  );
const EntrancePlantSettingsPage = () =>
import(
  /* webpackChunkName: "page-entranceplant-settings" */ '@/views/pages/EntrancePlantDetail/EntrancePlantSettings/EntrancePlantSettings.vue'
);
const EntrancePlantResidentsPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-residents" */ '@/views/pages/EntrancePlantDetail/EntrancePlantResidents/EntrancePlantResidents.vue'
  );
const EntrancePlantGuestsPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-guests" */ '@/views/pages/EntrancePlantDetail/EntrancePlantGuests/EntrancePlantGuests.vue'
  );
const EntrancePlantMessagesPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-messages" */ '@/views/pages/EntrancePlantDetail/EntrancePlantMessages/EntrancePlantMessages.vue'
  );
const EntrancePlantBadgesPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-badges" */ '@/views/pages/EntrancePlantDetail/EntrancePlantBadges/EntrancePlantBadges.vue'
  );
const EntrancePlantSwitchboardsPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-switchboards" */ '@/views/pages/EntrancePlantDetail/EntrancePlantSwitchboards/EntrancePlantSwitchboards.vue'
  );
const EntrancePlantStructureBuildingPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-structure-building" */ '@/views/pages/EntrancePlantDetail/EntrancePlantSettings/EntrancePlantStructure/EntrancePlantStructureBuilding/EntrancePlantStructureBuilding.vue'
  );
const EntrancePlantStructureRiserPage = () =>
  import(
    /* webpackChunkName: "page-entranceplant-structure-riser" */ '@/views/pages/EntrancePlantDetail/EntrancePlantSettings/EntrancePlantStructure/EntrancePlantStructureBuilding/EntrancePlantStructureRiser/EntrancePlantStructureRiser.vue'
  );

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main-container',
    redirect: { name: 'page-plants-hub' },
    component: MainContainer,
    beforeEnter: () => {},
    children: [
      {
        path: '/plants',
        name: 'page-plants-hub',
        component: PlantsHub,
        redirect: '/plants/list',
        meta: {
          title: `${APP_TITLE} - Plant list`,
        },
        children: [
          {
            path: 'list',
            name: 'page-plants-list',
            component: PlantsListPage,
          },
          {
            path: 'favourites',
            name: 'page-plants-favourites',
            component: PlantsListPage,
          },
          {
            path: 'staff',
            name: 'page-plants-staff',
            component: PlantsListPage,
          },
          {
            path: 'users',
            name: 'page-plants-users',
            component: PlantsListPage,
          },
          {
            path: 'edit',
            name: 'page-plants-edit',
            component: PlantsListPage,
          },
        ],
      },
      {
        path: '/plant/:plantId',
        name: 'page-plant-detail',
        component: PlantDetailHub,
        redirect: (to) => {
          return {
            name: 'page-plant-dashboard',
            params: to.params,
          };
        },
        meta: {
          requiresPlant: true,
          title: `${APP_TITLE} - Plant detail`,
        },
        children: [
          {
            path: 'dashboard',
            name: 'page-plant-dashboard',
            component: PlantDashboardPage,
          },
          {
            path: 'room/:roomId',
            name: 'page-plant-room',
            component: PlantRoomPage,
          },
          {
            path: 'devices',
            name: 'page-plant-devices',
            component: PlantDevicesPage,
          },
          {
            path: 'settings',
            name: 'page-plant-settings',
            component: PlantSettingsPage,
          },
          {
            path: 'rooms/:roomId/room-objects/:roomObjectId',
            name: 'page-assign-room-object',
            component: AutomationWizardPage,
          },
          {
            path: 'rooms/:roomId/room-objects/thermo/:roomObjectId',
            name: 'page-assign-thermo-room-object',
            component: ThermoWizardPage,
          },
          {
            path: 'commands-groups',
            name: 'page-commands-groups',
            component: CommandsGroupsPage,
          },
          {
            path: 'commands-groups/command-wizard/:id?',
            name: 'page-command-wizard',
            component: CommandWizard,
          },
          {
            path: 'scenes',
            name: 'page-plant-scenes',
            component: PlantScenesPage,
          },
          {
            path: 'scenes/wizard/:id?',
            name: 'page-scene-wizard',
            component: SceneWizard,
          },
          {
            path: 'alarmsystem',
            name: 'page-plant-alarmsystem',
            component: PlantAlarmSystem,
          },
        ],
      },
      {
        path: '/entranceplant/:plantId',
        name: 'page-entranceplant-detail',
        component: EntrancePlantDetailHub,
        redirect: (to) => {
          return {
            name: 'page-entranceplant-dashboard',
            params: to.params,
          };
        },
        meta: {
          requiresPlant: true,
          title: `${APP_TITLE} - Plant detail`,
        },
        children: [
          {
            path: 'dashboard',
            name: 'page-entranceplant-dashboard',
            component: EntrancePlantDashboardPage,
          },
          {
            path: 'gate/:gateId',
            name: 'page-entranceplant-gate',
            component: EntrancePlantGatePage,
          },
          {
            path: 'structure/:buildingId',
            name: 'page-entranceplant-structure-building',
            component: EntrancePlantStructureBuildingPage,
          },
          {
            path: 'structure/:buildingId/riser/:riserId',
            name: 'page-entranceplant-structure-riser',
            component: EntrancePlantStructureRiserPage,
          },
          {
            path: 'settings',
            name: 'page-entranceplant-settings',
            component: EntrancePlantSettingsPage,
          },
          {
            path: 'residents',
            name: 'page-entranceplant-residents',
            component: EntrancePlantResidentsPage,
          },
          {
            path: 'guests',
            name: 'page-entranceplant-guests',
            component: EntrancePlantGuestsPage,
          },
          {
            path: 'messages',
            name: 'page-entranceplant-messages',
            component: EntrancePlantMessagesPage,
          },
          {
            path: 'badges',
            name: 'page-entranceplant-badges',
            component: EntrancePlantBadgesPage,
          },
          {
            path: 'switchboards',
            name: 'page-entranceplant-switchboards',
            component: EntrancePlantSwitchboardsPage,
          },
        ],
      },
    ],
  },
  {
    path: '/logged-out',
    name: 'page-logged-out',
    component: LoggedOutPage,
    meta: {
      title: `${APP_TITLE} - logout`,
    },
  },
  {
    path: '/user-not-allowed',
    name: 'page-user-not-allowed',
    component: UserNotAllowedPage,
    meta: {
      title: `${APP_TITLE} - User not allowed`,
    },
  },
];

export default routes;
